module.exports = __webpack_public_path__ + "img/nodata.4c8eaa72.png";